import React from 'react';
import { Button, Inscription } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  hasNextItems?: boolean;
  onClick: () => void;
}

const LoadNextItemsButton: React.FC<Props> = ({ testId, hasNextItems, onClick }) => (
  <Button
    data-testid={`${testId}_load-more-button`}
    {...hasNextItems ? { onClick } : {}}
    style={{
      height: 'auto',
      minHeight: 'auto'
    }}  
  >
    <Inscription
      weight={500}
      color={hasNextItems ? 'navigationAccent' : 'textDisabled'}
    >
      {hasNextItems ? 'Load More' : 'End of the list'}
    </Inscription>
  </Button>
);

export default LoadNextItemsButton;
